// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm } from "react-hook-form";
// import { sendEmailValidation } from "../../../utils/validations/formValidations";
// import EmailIcon from '../../../assets/email.svg';
import { Drawer, message } from "antd";
import { useState } from "react";
import { SendEmail } from "../../../utils/api";
import ReactQuill from "react-quill";
import { imgPath } from "../../../utils/axiosInstance";

const SendEmailNotification = ({
  notificationDrawerData: { visible, data },
  setNotificationDrawerData,
  type,
}) => {
  const [loading, setLoading] = useState(false);
  const [emailText, setEmailText] = useState("");
  const [subject, setSubject] = useState("");
  // const { register, handleSubmit, formState: { errors, isValid }, reset } = useForm({ resolver: yupResolver(sendEmailValidation) });

  const handleEmailChange = (_content, _delta, _source, editor) => {
    const htmlContent = editor.getHTML();
    setEmailText(htmlContent);
  };

  const handleSubjectChange = (e) => {
    setSubject(e?.target?.value);
  };

  const onSubmit = async () => {
    message.destroy();
    const mailData = {
      type: type,
      email: data?.user?.email,
      subject: subject,
      message: emailText.replace(/<p>/g, "<div>").replace(/<\/p>/g, "</div>"),
    };
    if (!subject) {
      return message.error("Subject is required.");
    }
    if (emailText.length !== 0 && emailText !== "<p><br></p>") {
      try {
        setLoading(true);
        const resData = await SendEmail(mailData);
        if (resData?.isSuccess) {
          setEmailText("");
          message.success(`Mail sent to ${data?.user?.email}`);
          setNotificationDrawerData({ visible: false, data: null });
        } else {
          message.destroy();
          message.error(resData?.error);
        }
      } catch (error) {
        message.error(
          "An error occurred during the process. Please try again later.`"
        );
      } finally {
        setLoading(false);
      }
    } else {
      message.error("Email is required.");
    }
  };

  const handleCancel = () => {
    setNotificationDrawerData({ visible: false, data: null });
    // reset();
  };

  return (
    <Drawer
      contentWrapperStyle={{ width: "500px" }}
      className="send-email_drawer"
      title="Send Email Notification"
      placement="right"
      onClose={handleCancel}
      open={visible}
    >
      <div className="w-full bg-primary-300">
        <div className="w-full flex flex-col gap-y-3 px-6 py-3 border-bottom">
          {/* Header */}
          <div className="flex items-center justify-between gap-x-3 pl-2 py-2">
            <div className="flex gap-x-2 items-center">
              <img
                alt={data?.business_name}
                src={`${imgPath}${data?.image}`}
                className="w-8 h-8 object-cover rounded-full"
              />
              <p className="text-base text-black-700 font-medium">
                {data?.business_name}
              </p>
            </div>
            <span
              className={`${
                data?.statusType === "active"
                  ? "text-[green]"
                  : data?.statusType === "inactive"
                  ? "text-orange"
                  : data?.statusType === "blocked"
                  ? "text-[red]"
                  : ""
              } font-medium text-xs capitalize`}
            >
              {data?.statusType}
            </span>
          </div>

          <div className="w-full flex flex-col gap-y-2 text-xs font-medium pl-2">
            <div className="flex items-start">
              <span className="w-16 flex-shrink-0">Location:</span>
              <span className="text-black-500">{data?.business_location}</span>
            </div>
            <div className="flex items-center">
              <span className="w-16 flex-shrink-0">Email:</span>
              <span className="text-black-500">
                {data?.user?.email || "--"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="px-8 py-4">
        {/* <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate> */}
        <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative mt-2 mb-6">
          <label
            className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
            htmlFor="subject"
          >
            Subject
          </label>
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0" />

            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M4 12H20M4 8H20M4 16H12"
                stroke="#797979"
                stroke-width="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />{" "}
            </g>
          </svg>
          <input
            className="w-full outline-none text-[12px] text-input-placeholder"
            type="text"
            id="subject"
            value={subject}
            onChange={handleSubjectChange}
          />
        </div>
        {/* <p className="text-[red] text-[12px]">{errors.subject?.message}</p> */}
        {/* <div className="border border-input-placeholder flex items-start gap-x-2 rounded-lg p-3 relative mt-4">
            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="message">Message</label>
            <img src={EmailIcon} alt="message-svg" width={12} />
            <textarea className="w-full outline-none text-[12px] text-input-placeholder resize-none" rows={9} type="text" id="message" {...register('message')} />
          </div> */}
        <ReactQuill
          id="message"
          value={emailText}
          onChange={handleEmailChange}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ["bold", "italic", "underline", "strike", "blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["clean"],
            ],
          }}
          formats={[
            "header",
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            "list",
            "bullet",
          ]}
          placeholder="Write your email here..."
          style={{ margin: 0 }}
        />
        {/* <p className="text-[red] text-[12px]">{errors.message?.message}</p> */}
        <div className="mt-6 flex items-center justify-center gap-x-3">
          <span
            className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer"
            onClick={handleCancel}
          >
            Back
          </span>
          <button
            type="button"
            onClick={onSubmit}
            disabled={loading}
            className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2"
          >
            Submit
            {loading && <span className="loader"></span>}
          </button>
        </div>
        {/* </form> */}
      </div>
    </Drawer>
  );
};

export default SendEmailNotification;
